<template>
  <div :class="$style.container" class="add">
    <template v-if="isShowLoading">
        <loading></loading>
    </template>
    <h4>解绑银行卡</h4>
    <div :class="$style.content">
      <Form :model="form" :label-width="80" :rules="ruleValidate">     
        <FormItem label="银行卡号" style="width: 450px;">
          <Input v-model="form.accountNo" placeholder="" disabled />
        </FormItem>
        <FormItem label="开户行" style="width: 450px;">
          <Input v-model="form.bank.bankName" placeholder="" disabled />
        </FormItem>
        <FormItem label="手机号码" style="width: 750px;">
          <Row>
            <Col span="13" style="min-width:100px;margin-right:20px;">
            <Input v-model="form.phone" placeholder="" disabled />
            </Col>
          </Row>
        </FormItem>
        <FormItem style="width: 450px;margin-left:10px;">
          <Button type="primary" @click.stop="handleUntieClick" >解绑</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      isShowLoading: false,
      showModal: false,
      sendCode: false,
      activeNum: null,
      timer: null,
      btn_text: '获取验证码',
      form: {

      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写短信验证码",
            trigger: "blur"
          }
        ]
      },
      userId: ''
    };
  },
  watch: {
    info: {
      handler (val) {
        this.form = { ...val }
        if (this.form.bank && this.form.accountNo) {
          this.form.accountNo = '***************' + val.accountNo
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.userId = sessionStorage.getItem('userName')
  },
  methods: {
    // 解绑银行卡
    async handleUntieClick () {
      try {
        this.isShowLoading = true
        // alert(this.userId)
        let res = await this.$api.get(`${this.lee}/ec/bindBank/v1/jiebangUserBank`, {
          bindAgrNo: this.form.bindAgrNo,
          usid: this.userId
        })
        this.isShowLoading = false
        if (res.code === 200) {
          this.$Modal.warning({
            title: '温馨提示',
            content: res.msg
          });
          this.$emit('changeNo', 0)
        }

      } catch (err) {
        this.isShowLoading = false
      }
    },
    handleSendCodeClick () {
      let s = 60;
      this.btn_text = s + " s";
      this.timer = setInterval(() => {
        s--;
        this.btn_text = s + " s";
        if (s === 0) {
          this.btn_text = "获取验证码";
          clearInterval(this.timer);
          this.sendCode = false;
        }
      }, 1000);
      this.sendCode = true;
    }
  }
};
</script> 
<style lang="less" module>
.container {
  padding: 30px 20px;
  h4 {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
    margin-top: 20px;
  }
  .content {
    margin-top: 50px;
  }
}
</style>

<style scoped>
.add >>> .ivu-btn-text:focus {
  box-shadow: 0 0 0 0px rgba(45, 140, 240, 0.2);
}
</style>
